import { createContext, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import aViewGame from "../pages/2ViewGame";
import AddGame3 from "../pages/Archive/3AddGame";
import AddGame2 from "../pages/2AddGame";
import AddGameRoute from "../components/WorkingChessLogic/AddGameRoute";
import ViewGameRoute from "../components/WorkingChessLogic/ViewGameRoute";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";




export const ChessSocialContext = createContext();
export const ChessSocialProvider = ({ children }) => {
  const history = useHistory();
  const location = useLocation();
  const [user, setUser] = useState(null); // User data (e.g., profile information)
  const [activeTab, setActiveTabState] = useState("home");

  // Determine if on AddGame or ViewGame page
  const isAddGamePage = location.pathname === '/Analysis';
  const isViewGamePage = location.pathname.startsWith('/games/');

  // Initialize from localStorage based on current page
  const [showStockfish, setShowStockfish] = useState(() => {
    if (isAddGamePage) {
      const savedValue = localStorage.getItem('addGame_showStockfish');
      return savedValue !== null ? JSON.parse(savedValue) : true;
    } else if (isViewGamePage) {
      const savedValue = localStorage.getItem('viewGame_showStockfish');
      return savedValue !== null ? JSON.parse(savedValue) : true;
    }
    return false; // Default for other pages
  });

  const [evaluation, setEvaluation] = useState(0); // Add state for Stockfish evaluation
  const [currentFEN, setCurrentFEN] = useState("rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1"); // Default starting position --> Stockfish edit... may cause issue.

  // Initialize StockfishEval visibility from localStorage based on current page
  const [showStockfishEval, setShowStockfishEval] = useState(() => {
    if (isAddGamePage) {
      const savedValue = localStorage.getItem('addGame_showStockfishEval');
      return savedValue !== null ? JSON.parse(savedValue) : true;
    } else if (isViewGamePage) {
      const savedValue = localStorage.getItem('viewGame_showStockfishEval');
      return savedValue !== null ? JSON.parse(savedValue) : true;
    }
    return true; // Default for other pages
  });

  // New state for the Stockfish control panel visibility
  const [showStockfishPanel, setShowStockfishPanel] = useState(false);

  // New state for emoji and stockfish icons toggles
  const [showEmoji, setShowEmoji] = useState(false);

  // Initialize showStockfishIcons from localStorage based on current page
  const [showStockfishIcons, setShowStockfishIcons] = useState(() => {
    if (isAddGamePage) {
      // First try the simple key used in AddGame.js
      const simpleValue = localStorage.getItem('showStockfishIcons');
      if (simpleValue !== null) {
        return simpleValue === 'true';
      }
      // Fall back to the prefixed key if needed
      const savedValue = localStorage.getItem('addGame_showStockfishIcons');
      return savedValue !== null ? JSON.parse(savedValue) : false;
    } else if (isViewGamePage) {
      const savedValue = localStorage.getItem('viewGame_showStockfishIcons');
      return savedValue !== null ? JSON.parse(savedValue) : false;
    }
    return false; // Default for other pages
  });

  // Initialize showArrows from localStorage based on current page
  const [showArrows, setShowArrows] = useState(() => {
    if (isAddGamePage) {
      // Always true for AddGame
      return true;
    } else if (isViewGamePage) {
      const savedValue = localStorage.getItem('viewGame_showArrows');
      return savedValue !== null ? JSON.parse(savedValue) : true;
    }
    return true; // Default for other pages
  });

  // New state for stockfish arrows
  const [stockfishArrows, setStockfishArrows] = useState([]);

  // Reset Stockfish engine to OFF when navigating to a new ViewGame page
  useEffect(() => {
    if (location.pathname.startsWith('/games/')) {
      // Instead of resetting state here, rely on values read from localStorage
      // Only apply defaults if no localStorage values exist
      const savedValue = localStorage.getItem('viewGame_showStockfish');
      if (savedValue === null) {
        // Only set default if no saved value
        setShowStockfish(false);
      }
    }
  }, [location.pathname]);

  // +++ NEW STATE: Track if the current mode is a Puzzle +++
  const [isPuzzleMode, setIsPuzzleMode] = useState(false);
  // +++ END NEW STATE +++

  // Helper function to check if the current path should have a collapsed sidebar
  const shouldHaveCollapsedSidebar = (pathname) => {
    // These paths should always start with collapsed sidebar
    return pathname === '/PlayChess' ||
      pathname === '/Premium' ||
      pathname === '/Premium-Portal' ||
      pathname === '/Analysis' ||
      pathname.startsWith('/games/');
  };

  // Initialize sidebar state based on location
  // Start expanded when first logging in to portal
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(() => {
    // Special exception for portal - always start expanded
    if (location.pathname === '/portal' || location.pathname === '/Portal') {
      return false;
    }
    // Force collapsed state on specific pages
    return shouldHaveCollapsedSidebar(location.pathname);
  });

  // Add effect to handle route changes - collapse on all navigation
  useEffect(() => {
    // Always collapse sidebar on navigation, except for initial portal load
    if (location.pathname !== '/portal' && location.pathname !== '/Portal') {
      setIsSidebarCollapsed(true);
    }
  }, [location.pathname]);

  // Add effect to dispatch a custom event when sidebar state changes
  // This allows components to listen for sidebar state changes and adjust their layout
  useEffect(() => {
    // Create and dispatch a custom event when sidebar state changes
    const event = new CustomEvent('sidebarStateChanged', {
      detail: { collapsed: isSidebarCollapsed }
    });
    document.dispatchEvent(event);
  }, [isSidebarCollapsed]);

  // We're no longer saving sidebar state to localStorage per requirements
  // Remove the localStorage useEffect

  const token = localStorage.FBIdToken;

  // Modify setActiveTab to always collapse sidebar when navigating
  const setActiveTab = (newTab) => {

    setActiveTabState(newTab);

    // Always collapse sidebar when navigating using tab buttons
    setIsSidebarCollapsed(true);

    switch (newTab) {
      case "home":
        history.push("/");
        break;
      // case "explore":
      //   history.push("/Explore");
      //   break;
      case "AddGameRoute":
        history.push("/Analysis");
        break;
      // case "play":
      //   history.push("/Play");
      //   break;

      // TODO: Add back in when we have a premium running
      // case "PremiumVerified":
      //   history.push("/Premium-Portal");
      //   break;


      // case "PlayChess":
      //   history.push("/PlayChess");
      //   break;
      // case "Lila":
      //   history.push("/Lila");
      //   break;
      case "bookmark":
        history.push("/Bookmark");
        break;
      case "profile":
        history.push("/profile");
        break;
      case "terms":
        history.push("/Terms");
        break;
      case "privacy":
        history.push("/Privacy");
        break;
      case "support":
        history.push("/Support");
        break;
      // TODO: Add back in when we have a premium running
      // case "Premium":
      //   history.push("/Premium");
      //   break;
      case "interaction":
        history.push("/Interaction");
        break;
      case "game":
        history.push("/Game");
        break;
      case "pro":
        history.push("/Profile");
        break;
      case "friends":
        history.push("/Friends");
        break;
      case "portal":
        history.push("/Portal");
        break;
      case "Landing":
        history.push("/Landing");
        break;
      case "Settings":
        history.push("/Settings");
        break;
      
      case "AddGame2":
        history.push("/AddGame2");
        break;
      case "ViewGame2":
        history.push("/ViewGame2");
        break;

      // case "LiChessFAQ":
      //   history.push("/LiChessFAQ");
      //   break;
      default:
        break;
    }
  };

  // We should sync the context values with localStorage whenever they change
  useEffect(() => {
    if (isViewGamePage) {
      localStorage.setItem('viewGame_showArrows', JSON.stringify(showArrows));
    }
  }, [showArrows, isViewGamePage]);

  useEffect(() => {
    if (isViewGamePage) {
      localStorage.setItem('viewGame_showStockfish', JSON.stringify(showStockfish));
    } else if (isAddGamePage) {
      localStorage.setItem('showStockfish', showStockfish);
      localStorage.setItem('addGame_showStockfish', JSON.stringify(showStockfish));
    }
  }, [showStockfish, isViewGamePage, isAddGamePage]);

  useEffect(() => {
    if (isViewGamePage) {
      localStorage.setItem('viewGame_showStockfishEval', JSON.stringify(showStockfishEval));
    } else if (isAddGamePage) {
      localStorage.setItem('addGame_showStockfishEval', JSON.stringify(showStockfishEval));
    }
  }, [showStockfishEval, isViewGamePage, isAddGamePage]);

  // Update localStorage when showStockfishIcons changes
  useEffect(() => {
    if (isViewGamePage) {
      localStorage.setItem('viewGame_showStockfishIcons', JSON.stringify(showStockfishIcons));
    } else if (isAddGamePage) {
      // Use both keys to ensure compatibility with AddGame.js
      localStorage.setItem('showStockfishIcons', showStockfishIcons);
      localStorage.setItem('addGame_showStockfishIcons', JSON.stringify(showStockfishIcons));
    }
  }, [showStockfishIcons, isViewGamePage, isAddGamePage]);

  // --- Add Logging Effect ---
  useEffect(() => {
  }, [stockfishArrows]);
  // --- End Logging Effect ---

  return (
    <ChessSocialContext.Provider
      value={{
        setActiveTab,
        activeTab,
        showStockfish,
        setShowStockfish,
        showStockfishEval,
        setShowStockfishEval,
        showStockfishPanel,
        setShowStockfishPanel,
        isSidebarCollapsed,
        setIsSidebarCollapsed,
        // Add new state variables to context
        showEmoji,
        setShowEmoji,
        showStockfishIcons,
        setShowStockfishIcons,
        showArrows,
        setShowArrows,
        stockfishArrows,
        setStockfishArrows,
        // Add evaluation state to context
        evaluation,
        setEvaluation,
        // Add currentFEN state to context
        currentFEN,
        setCurrentFEN,
        // Add new state variable to context
        isPuzzleMode,
        setIsPuzzleMode
      }}
    >
      {children}
    </ChessSocialContext.Provider>
  );
};
